import { useContext, useEffect, useState } from "react";
import { useCurrentUser } from "../CurrentUserProvider";
import {
    BaseRealtime,
    WebSocketTransport,
    FetchRequest,
    RealtimePresence,
} from "ably/modular";
import * as AblyReact from "ably/react";
import { useFirstRender } from "hooks/useFirstRender";
import { RealtimeContext } from "./RealtimeContext";

export const DetachableChannelProvider = (channelProviderProps) => {
    const ablyClient = useContext(RealtimeContext).useAbly?.();
    const { channelName } = channelProviderProps;

    useEffect(() => {
        if (ablyClient) {
            ablyClient.channels.get(channelName).attach();
            return () => {
                const channel = ablyClient.channels.get(channelName);
                setTimeout(async () => {
                    if (
                        (channel.state === "attaching" ||
                            channel.state === "attached") &&
                        channel.subscriptions.any.length === 0 &&
                        channel.subscriptions.anyOnce.length === 0 &&
                        Object.keys(channel.subscriptions.events).length ===
                            0 &&
                        Object.keys(channel.subscriptions.eventsOnce).length ===
                            0 &&
                        channel.presence.subscriptions.any.length === 0 &&
                        channel.presence.subscriptions.anyOnce.length === 0 &&
                        Object.keys(channel.presence.subscriptions.events)
                            .length === 0 &&
                        Object.keys(channel.presence.subscriptions.eventsOnce)
                            .length === 0
                    ) {
                        await channel.detach();
                    }
                }, 2500);
            };
        }
    }, [ablyClient, channelName]);

    const ChannelProvider = useContext(RealtimeContext).ChannelProvider;

    return ChannelProvider ? (
        <ChannelProvider {...channelProviderProps} />
    ) : (
        channelProviderProps.children
    );
};

const createClient = () =>
    new BaseRealtime({
        authUrl: "/api/realtime_auth",
        authMethod: "POST",
        plugins: {
            WebSocketTransport,
            FetchRequest,
            RealtimePresence,
        },
    });

export const RealtimeProvider = ({ children }) => {
    const { currentUser } = useCurrentUser();
    const [client, setClient] = useState(() => createClient());
    const firstRender = useFirstRender();

    useEffect(() => {
        !firstRender &&
            setClient((prevClient) => {
                const newClient = createClient();
                newClient.connection.on("connected", () => prevClient.close());
                return newClient;
            });
    }, [currentUser?.id]);

    return (
        <AblyReact.AblyProvider client={client}>
            <RealtimeContext.Provider value={AblyReact}>
                {children}
            </RealtimeContext.Provider>
        </AblyReact.AblyProvider>
    );
};
